export enum UserStatusEnum {
  InvitePending = 0,
  Active = 1,
  Suspended = 2
}
